module.exports = __webpack_public_path__ + "media/images/icons/tick-e7656495290fae493342fed26b042af9.svg";